// extracted by mini-css-extract-plugin
export default {"CurrentPlan":"uT5QJC2U"};